import { serverCall } from 'utils/serverCall';
import {
  initRegionListRequest,
  setRegionList,
  addRegion,
  errorRegion,
  errorRegionList,
  setRegion,
  updateRegion,
  deleteRegion,
} from './action'; 
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchRegionList = ({ searchQuery = null, currentPage = null, rowsPerPage = null } = {}) => {
  return async (dispatch) => {
    dispatch(initRegionListRequest());
    const params = new URLSearchParams();
    if (searchQuery !== null && searchQuery !== undefined && searchQuery !== '') {
      params.append('search', searchQuery);
    }
    if (currentPage !== null) params.append('page', currentPage);
    if (rowsPerPage !== null) params.append('limit', rowsPerPage);

    try {
      const queryString = params.toString();
      const url = queryString ? `${apiEndpoints.REGION_LIST}?${queryString}` : apiEndpoints.REGION_LIST;
      const result = await serverCall(url, 'GET', dispatch);
      if (result.success) {
        // Expected payload structure: { success: true, message: "...", payload: { data: [...], pagination: {...} } }
        const payloadData = result?.data?.payload || result?.data;
        dispatch(setRegionList(payloadData));
      } else {
        dispatch(errorRegionList(result.message));
      }
    } catch (error) {
      dispatch(errorRegionList(error.message));
    }
  };
};

export const createRegion = (regionData, toggleModal) => {
  return async (dispatch) => {
    dispatch(initRegionListRequest());
    try {
      const payload = {
        name: regionData.name,
        address: regionData.address,
      };
      const result = await serverCall(apiEndpoints.REGION_CREATE, 'POST', dispatch, payload);
      if (result.success) {
        dispatch(addRegion(result?.data?.payload));
        dispatch(fetchRegionList());
        toggleModal();
        toast.success(result?.data?.message || 'Region created successfully');
        return Promise.resolve();
      } else {
        toast.error(result.message || 'Failed to create region');
        dispatch(errorRegion(result.message));
      }
    } catch (error) {
      toast.error(error.message || 'Error creating region');
      dispatch(errorRegion(error.message));
      return Promise.reject(error);
    }
  };
};

export const fetchRegionById = (regionId, stateToManage) => {
  return async (dispatch) => {
    dispatch(initRegionListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.REGION_BYID}/${regionId}`, 'GET', dispatch);
      if (result.success) {
        const payloadData = result?.data?.payload || result?.data;
        dispatch(setRegion(payloadData));
        if (stateToManage) {
          stateToManage((prevState) => !prevState);
        }
      } else {
        dispatch(errorRegion(result.message));
      }
    } catch (error) {
      dispatch(errorRegion(error.message));
    }
  };
};

export const updateRegionById = (regionId, regionData, toggleModal, searchQuery = '') => {
  return async (dispatch) => {
    dispatch(initRegionListRequest());
    try {
      const payload = {
        name: regionData.name,
        address: regionData.address,
      };
      let result = await serverCall(`${apiEndpoints.REGION_UPDATE}/${regionId}`, 'POST', dispatch, payload);
      if (!result.success && result.message?.includes('Method Not Allowed')) {
        result = await serverCall(`${apiEndpoints.REGION_UPDATE}/${regionId}`, 'PUT', dispatch, payload);
      }
      if (result.success) {
        dispatch(updateRegion(result?.data?.payload || result?.data));
        dispatch(fetchRegionList({ searchQuery }));
        if (toggleModal) toggleModal();
        toast.success(result?.data?.message || 'Region updated successfully');
      } else {
        toast.error(result.message || 'Failed to update region');
        dispatch(errorRegion(result.message));
      }
    } catch (error) {
      toast.error(error.message || 'Error updating region');
      dispatch(errorRegion(error.message));
    }
  };
};

export const deleteRegionById = (regionId, toggleModal) => {
  return async (dispatch) => {
    dispatch(initRegionListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.REGION_DELETE}/${regionId}`, 'DELETE', dispatch);
      if (result.success) {
        dispatch(deleteRegion(regionId));
        dispatch(fetchRegionList());
        toast.success(result?.data?.message || 'Region deleted successfully');
        if (toggleModal) toggleModal();
      } else {
        toast.error(result.message || 'Failed to delete region');
        dispatch(errorRegion(result.message));
      }
    } catch (error) {
      toast.error(error.message || 'Error deleting region');
      dispatch(errorRegion(error.message));
    }
  };
};

